import React, { FC } from 'react';

import { Notification as NotificationModel } from 'api-client';
import { cn } from 'utils';

import styles from './NotificationBadges.module.scss';

interface Props {
  notification: NotificationModel;
  className?: string;
}

const NotificationBadges: FC<Props> = ({ notification, className }) => {
  if (!notification.isImportant && notification.isRead) {
    return null;
  }

  return (
    <div className={cn(styles.badges, className)}>
      {notification.isImportant && (
        <span className={cn(styles.badge, styles.important)}>Важное</span>
      )}
      {!notification.isRead && <span className={cn(styles.badge, styles.new)}>Новое</span>}
    </div>
  );
};

export default NotificationBadges;
